import { LeaderboardStats, UserRankings } from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

export const getAllLeaderboardStats = async (_): Promise<LeaderboardStats> => {
  return await fetchFromAPI(`/leaderboards`);
};

export enum LeaderboardPathType {
  Members = "members-trees",
  Business = "business-trees",
  Referral = "sparkly-trees",
}

export const getLeaderboardStatsByType = async (
  _,
  path: LeaderboardPathType
): Promise<UserRankings[]> => {
  return await fetchFromAPI(`/leaderboards/${path}`);
};
